import { useState } from "react";
import { InputField } from "./inputField";

interface PasswordFieldProps {
  value: string;
  onChange: (value: string) => void;
  onGenerate?: () => void;
  label?: string;
  placeholder?: string;
  className?: string;
}

export const PasswordField = ({
  value,
  onChange,
  onGenerate,
  label,
  placeholder,
  className = "",
}: PasswordFieldProps) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className={`space-y-2 ${className}`.trim()}>
      {label && <label className="text-label">{label}</label>}
      <div className="relative">
        <InputField
          type={showPassword ? "text" : "password"}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          inputClassName="pr-10"
          className=""
        />
        {value && (
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="password-field-toggle absolute top-1/2 -translate-y-1/2 transition-colors duration-200 p-1.5 rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-(--color-focus-ring)"
            style={{ right: "var(--space-2)" }}
            aria-label={
              showPassword ? "Ocultar contraseña" : "Mostrar contraseña"
            }
          >
            {showPassword ? (
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                strokeWidth={2.25}
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
                />
              </svg>
            ) : (
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                strokeWidth={2.25}
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                />
              </svg>
            )}
          </button>
        )}
      </div>
      {onGenerate && (
        <button
          type="button"
          onClick={onGenerate}
          className="w-full flex items-center justify-center bg-global-overlay-secondary border border-global-secondary text-size-xs font-semibold uppercase tracking-wider text-global-accent hover:bg-global-accent-overlay hover:border-global-accent hover:text-global-title-accent transition-all duration-200 active:scale-[0.98] group gap-2 px-3 py-2 rounded-lg"
        >
          <svg
            className="w-3.5 h-3.5 group-hover:rotate-180 transition-transform duration-500"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
            />
          </svg>
          <span>Generar contraseña aleatoria</span>
        </button>
      )}
    </div>
  );
};
